import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { setMessage } from './message';

import customerService from '../services/customer.service';


export const fetchCustomerList = createAsyncThunk(
    'customer/fetchCustomerList',
    async ({ page, pagesize, search, groupId, ordering }, thunkAPI) => {
        try {
            const response = await customerService.getCustomerList(page, pagesize, search, groupId, ordering);
            return response.data;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    },
);

export const fetchCustomerDropdown = createAsyncThunk(
    'customer/fetchCustomerDropdown',
    async ({ page, pagesize, search, groupId, ordering }, thunkAPI) => {
        try {
            const response = await customerService.getCustomerDropdown(page, pagesize, search, groupId, ordering);
            return response.data;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    },
);


export const fetchActiveCustomer = createAsyncThunk(
    'customer/fetchActiveCustomer',
    async ({ page, pagesize, search, ordering }, thunkAPI) => {
        try {
            const response = await customerService.getActiveCustomerList(page, pagesize, search, ordering);
            return response.data;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    },
);


export const fetchCustomerConversionList = createAsyncThunk(
    'customer/fetchCustomerConversionList',
    async ({ page, pagesize, search, customer_id, ordering, die_id }, thunkAPI) => {
        try {
            const response = await customerService.getCustomerConversion(page, pagesize, search, customer_id, die_id, ordering);
            return response.data;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    },
);
export const fetchCustomerConversionValue = createAsyncThunk(
    'customer/fetchCustomerConversionValue',
    async ({ page, pagesize, search, customer_id,  die_id,alloy_id,temper_id }, thunkAPI) => {
        try {
            const response = await customerService.getCustomerConversionValue(page, pagesize, search, customer_id, die_id, alloy_id,temper_id);
            return response.data;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    },
);
export const fetchArchivedCustomerList = createAsyncThunk(
    'customer/fetchArchivedCustomerList',
    async ({ page, pagesize, search, ordering }, thunkAPI) => {
        try {
            const response = await customerService.getCustomerArchiveList(page, pagesize, search, ordering);
            return response.data;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    },
);
export const fetchCustomerById = createAsyncThunk(
    'customer/fetchCustomerById',
    async (dieProfileId, { rejectWithValue }) => {
        try {
            const response = await customerService.getCustomerById(dieProfileId);
            return response.data; // Return the profile data
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);
export const createCustomer = createAsyncThunk(
    'customer/createCustomer',
    async ({ formattedData, customerLogo }, thunkAPI) => {
        try {
            const formPayload = new FormData();
            formPayload.append('form_data', JSON.stringify(formattedData));

            if (customerLogo) {
                formPayload.append('customer_logo', customerLogo);
            }
            const response = await customerService.addCustomer(formPayload);
            return response.data;
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    }
);
export const createQuickCustomer = createAsyncThunk(
    'customer/createQuickCustomer',
    async ({ values }, thunkAPI) => {
        try {
            const response = await customerService.addQuickCustomer(values);
            return response.data;
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    }
);
export const updateCustomer = createAsyncThunk(
    'customer/updateCustomer',
    async ({ id, values, customerLogo }, thunkAPI) => {
        try {
            const filteredContactPersons = values.customer_contact_persons?.map(({ created_by, updated_by, updated_at, created_at, deleted, ...rest }) => rest) || [];
            const filteredBankingDetails = values.customer_banking_details?.map(({ created_by, updated_by, updated_at, created_at, deleted, ...rest }) => rest) || [];
            const payload = {
                gstin_number: values.gstin_number,
                gst_type: values.gst_type,
                pan_number: values.pan_number,
                customer_name: values.customer_name,
                import_export_code: values.import_export_code,
                beneficiary_agent_code: values.beneficiary_agent_code,
                business_type: values.business_type,
                trade_name: values.trade_name,
                code: values.code,
                designation: values.designation,
                fax_number: values.fax_number,
                website: values.website,
                person_name: values.person_name,
                email: values.email,
                phone_number: values.phone_number,
                customer_type: values.customer_type,
                delivery_days: values.delivery_days,
                udyam_no: values.udyam_no,
                applicable_gst: values.applicable_gst,
                customer_section_no: values.customer_section_no,
                office_address_shop: values.office_address_shop,
                office_address_area: values.office_address_area,
                office_address_landmark: values.office_address_landmark,
                office_address_pin_code: values.office_address_pin_code,
                office_address_city: values.office_address_city,
                office_address_state: values.office_address_state,
                factory_address_shop: values.factory_address_shop,
                factory_address_area: values.factory_address_area,
                factory_address_landmark: values.factory_address_landmark,
                factory_address_pin_code: values.factory_address_pin_code,
                factory_address_city: values.factory_address_city,
                factory_address_state: values.factory_address_state,
                sales_executive: values.sales_executive?.value,
                sales_executive_assistant: values.sales_executive_assistant?.value,
                customer_contact_persons: filteredContactPersons.length > 0
                    ? filteredContactPersons
                    : [{ contact_person_name: '', contact_person_designation: '', contact_person_mobile_number: '', contact_person_email: '' }],
                customer_banking_details: filteredBankingDetails.length > 0
                    ? filteredBankingDetails
                    : [{ bank_name: '', bank_account_number: '', bank_ifsc_code: '', bank_branch_address: '', bank_ad_code: '', beneficiary_swift_code: '' }]
            };

            const formPayload = new FormData();
            formPayload.append('form_data', JSON.stringify(payload));

            if (customerLogo) {
                formPayload.append('customer_logo', customerLogo);
            }
            const response = await customerService.updateCustomer(id, formPayload);

            return response.data; // Return the updated customer data
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    }
);


export const deleteCustomer = createAsyncThunk(
    'customer/deleteCustomer',
    async (id, thunkAPI) => {
        try {
            await customerService.deleteCustomer(id); // Ensure `id` is used here
            return id; // Return the ID of the deleted group
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    }
);


export const unArchiveCustomer = createAsyncThunk(
    'customer/unArchiveCustomer',
    async (id, thunkAPI) => {
        try {
            await customerService.unArchiveCustomerRecord(id); // Ensure `id` is used here
            return id; // Return the ID of the deleted group
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    }
);

const initialState = {
    data: [], // List
    list: [],
    totalPages: 0,
    currentPage: 1,
    totalRecord: 0,
    status: 'idle',
    error: null,
    loading: false,
    hasMore: true,
};


const customerSlice = createSlice({
    name: 'customer',
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        resetCustomerData: (state) => {
            state.data = []; // This will clear the list
        },
        resetCustomerList: (state) => {
            state.list = []; // This will clear the list
        },
        resetCurrentCustomerPage: (state) => {
            state.currentPage = 1;
        }
    },
    extraReducers: builder => {
        builder
            .addCase(fetchCustomerList.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchCustomerList.fulfilled, (state, action) => {
                state.status = 'succeeded';
                const fetchedPage = action.payload.page || state.currentPage;
                state.data = action.payload.results.data || [];  // Update to match your API response
                state.totalRecord = action.payload.count || 0; // Handle count (total records)
                state.totalPages = action.payload.totalPages || 0; // Handle totalPages
                state.currentPage = action.payload.next ? fetchedPage + 1 : fetchedPage;
                state.list = [...state.list, ...action.payload.results.data];
                state.hasMore = !!action.payload.next;
            })
            .addCase(fetchCustomerList.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
            });


        builder
            .addCase(fetchCustomerDropdown.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchCustomerDropdown.fulfilled, (state, action) => {
                state.status = 'succeeded';
                const fetchedPage = action.payload.page || state.currentPage;
                state.data = action.payload.results.data || [];  // Update to match your API response
                state.totalRecord = action.payload.count || 0; // Handle count (total records)
                state.totalPages = action.payload.totalPages || 0; // Handle totalPages
                state.currentPage = action.payload.next ? fetchedPage + 1 : fetchedPage;
                state.list = [...state.list, ...action.payload.results.data];
                state.hasMore = !!action.payload.next;
            })
            .addCase(fetchCustomerDropdown.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
            });

         builder
            .addCase(fetchActiveCustomer.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchActiveCustomer.fulfilled, (state, action) => {
                state.status = 'succeeded';
                const fetchedPage = action.payload.page || state.currentPage;
                state.data = action.payload.data || [];  // Update to match your API response
                state.totalRecord = action.payload.count || 0; // Handle count (total records)
                state.totalPages = action.payload.totalPages || 0; // Handle totalPages
                state.currentPage = action.payload.next ? fetchedPage + 1 : fetchedPage;
                state.list = [...state.list, ...action.payload.data];
                state.hasMore = !!action.payload.next;
            })
            .addCase(fetchActiveCustomer.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
            });

        builder
            .addCase(fetchArchivedCustomerList.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchArchivedCustomerList.fulfilled, (state, action) => {
                state.status = 'succeeded';
                const fetchedPage = action.payload.page || state.currentPage;
                state.data = action.payload.results.data || [];  // Update to match your API response
                state.totalRecord = action.payload.count || 0; // Handle count (total records)
                state.totalPages = action.payload.totalPages || 0; // Handle totalPages
                state.currentPage = action.payload.next ? fetchedPage + 1 : fetchedPage;
                state.list = [...state.list, ...action.payload.results.data];
                state.hasMore = !!action.payload.next;
            })
            .addCase(fetchArchivedCustomerList.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
            });
        builder
            .addCase(fetchCustomerById.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchCustomerById.fulfilled, (state, action) => {
                state.loading = false;
                state.activeProfileRecord = action.payload;
            })
            .addCase(fetchCustomerById.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
        builder
            .addCase(createCustomer.pending, state => {
                state.status = 'loading';
            })
            .addCase(createCustomer.fulfilled, (state, action) => {
                state.status = 'succeeded';
            })
            .addCase(createCustomer.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })
            .addCase(createQuickCustomer.pending, state => {
                state.status = 'loading';
            })
            .addCase(createQuickCustomer.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data.push(action.payload); // Add the newly created group to the list
            })
            .addCase(createQuickCustomer.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })
        builder
            .addCase(updateCustomer.pending, state => {
                state.status = 'loading';
            })
            .addCase(updateCustomer.fulfilled, (state, action) => {
                state.status = 'succeeded';
                const updateDieProfile = action.payload;
                const index = state.data.findIndex(group => group.id === updateDieProfile.id); // Find the index of the updated group
                if (index !== -1) {
                    state.data[index] = updateDieProfile; // Replace the old group with the updated one
                }
            })
            .addCase(updateCustomer.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            });
        builder
            .addCase(deleteCustomer.pending, state => {
                state.status = 'loading';
            })
            .addCase(deleteCustomer.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = state.data.filter(group => group.id !== action.payload); // Remove the deleted group from state
                state.list = state.list.filter(group => group.id !== action.payload); // Remove the deleted group from list
            })
            .addCase(deleteCustomer.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
                state.error = action.error.message;
            });
        builder
            .addCase(unArchiveCustomer.pending, state => {
                state.status = 'loading';
            })
            .addCase(unArchiveCustomer.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = state.data.filter(group => group.id !== action.payload); // Remove the deleted group from state
            })
            .addCase(unArchiveCustomer.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export const { resetCustomerData, resetCustomerList, resetCurrentCustomerPage } = customerSlice.actions;
export default customerSlice.reducer;
